



































































import TopToolbar from "@/components/TopToolbar.vue";
import BottomNav from "@/components/BottomNav.vue";
import { Data, On, Route, RouteParam } from "@rocketbase/vue-extra-decorators";
import { Component, Vue } from "vue-property-decorator";

@Route({
  path: "/overviewitem/:itemName/:itemDate",
  name: "overviewitem"
})
@Component({
  components: { TopToolbar, BottomNav }
})
export default class ItemOverview extends Vue {
  @RouteParam("itemName")
  private itemName!: string;

  @RouteParam("itemDate")
  private itemDate!: string;

  @Data({ default: [] })
  private selected!: [];

  @Data({ default: false })
  private dialog!: boolean;

  @Data({
    default: [
      {
        text: "Datum",
        align: "start",
        sortable: false,
        value: "date"
      },
      {
        text: "Portionen",
        align: "start",
        sortable: false,
        value: "portions"
      },
      {
        text: "Schrank",
        align: "start",
        sortable: false,
        value: "locker.name"
      },
      {
        text: "Fach",
        align: "start",
        sortable: false,
        value: "subject"
      }
    ]
  })
  private headers!: [];

  //@Watch({ prop: "$route", deep: true, immediate: true })
  @On("hook:mounted")
  private async onRouteChange() {
    const { itemName, itemDate } = this;
    if (itemName && itemDate) {
      const items = await this.$store.dispatch("overviewItem", {
        name: itemName,
        date: itemDate
      });
      if (typeof items !== "undefined" && items.length == 0)
        this.$router.push("/");
    }
  }

  private async successDelete() {
    this.dialog = false;
    const status = await this.$store.dispatch(
      "deleteItems",
      this.selected.map(i => {
        const { id } = i;
        return id;
      })
    );
    if (status === 200) this.$router.back();
  }

  private itemClicked(item: { id: string }) {
    this.$store.commit("setItem", item);
    this.$router.push("/item/" + item.id);
  }
}
